import { motion } from 'framer-motion';
import { useEditor } from '@smartfire/js-block-engine';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import { ReactComponent as Place } from './place.svg';
import { ReactComponent as Slash } from './longSlash.svg';
import { format, isValid } from 'date-fns';
import fr from 'date-fns/locale/fr';
import style from './style.module.scss';
import clsx from 'clsx';
import { useMemo } from 'react';

function parseDate(value) {
    try {
        const date = new Date(value);
        if (isValid(date)) {
            return date;
        } else {
            throw new Error(value + ' is an invalid date');
        }
    } catch (e) {
        console.error(e);
        return undefined;
    }
}

const TileEvent = ({
    picture,
    alt,
    link,
    title,
    gmapLink,
    dates,
    place,
    listing = false,
    i,
    imageHeight = 320,
    marginTop = 0,
}) => {
    const { isEditing } = useEditor();
    const TagName = isEditing ? 'div' : 'a';

    const startDate = useMemo(() => parseDate(dates?.start), [dates?.start]);
    const endDate = useMemo(() => parseDate(dates?.end), [dates?.end]);

    return (
        <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0 }}
            transition={{ delay: 0.2 * i, y: { duration: 0.3 } }}
            className={clsx(style.tilePost, listing && style.listing)}
            style={{ marginTop: marginTop + 'px', gridTemplateRows: imageHeight + 'px auto' }}
        >
            <TagName href={!isEditing ? link : undefined} className={style.zoom} style={{ height: imageHeight + 'px' }}>
                <LazyLoadImage effect={'opacity'} wrapperClassName={style.imageWrapper} src={picture} alt={alt} />
                <div className={style.seeLink}>Voir</div>
            </TagName>
            <div className={style.tileContent}>
                <div className={style.left}>
                    <a href={gmapLink} target="_blank" rel="noopener noreferrer" className={style.place}>
                        <Place />
                        {place}
                    </a>
                    <a href={link} dangerouslySetInnerHTML={{ __html: title }} className={style.title} />
                    <a href={link} className={style.button}>
                        Voir plus
                    </a>
                </div>
                {endDate && startDate && (
                    <div className={clsx(style.right, dates.start !== dates.end && style.double)}>
                        {dates.start !== dates.end && (
                            <div className={style.date}>
                                <p className={style.up}>{format(startDate, 'dd', { locale: fr })}</p>
                                <p className={style.down}>{format(startDate, 'MMM', { locale: fr })}</p>
                            </div>
                        )}
                        <Slash />
                        <div className={style.date}>
                            <p className={style.up}>{format(endDate, 'dd', { locale: fr })}</p>
                            <p className={style.down}>{format(endDate, 'MMM', { locale: fr })}</p>
                        </div>
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default TileEvent;
